// extracted by mini-css-extract-plugin
export default {"container":"SimplePanelLayout_container__mwSV0"};